import React from 'react';
import { Dropdown } from 'antd';

import { icons } from '../../../constants';
import { Icon, Button, DropDownMenu } from '..';


export const DropdownButton = ({ icon, dropdownItems, label, disabled = false }) => (
  <Dropdown
    overlay={ <DropDownMenu items={ dropdownItems } /> }
  >
    <div>
      <Button additions={ [ 'fit-content', 'outlined-blue' ] } disabled={ disabled }>
        <Icon
          svg={ icon }
          svgProps={{ width: '20', height: '20' }}
          additions={ [ 'button-first' ] }
        />
        { label }
        <Icon
          svg={ icons.MENU_D_ARROW }
          svgProps={{ width: '12', height: '18' }}
          additions={ [ 'button-second' ] }
        />
      </Button>
    </div>
  </Dropdown>
);
